import React from 'react'
import classnames from 'classnames'

import { Card } from 'react-bootstrap'

const Message = ({data, youId}) =>{
    const { name, message, attachment, time, author} = data;
    const own = author === youId;
    return(
        <div className= {classnames('w-100 d-flex', {'justify-content-end': own})}>
            <Card className={
                classnames('shadow-lg rounded py-0 mb-2 text-white ', 
                    {'bg-success': own},
                    {'bg-dark': !own},
                    )} 
                style={{maxWidth: '60%'}}>
                <Card.Header className={classnames('py-0 px-2 my-0 font8', {'d-none': own})}>
                    <span>{name}</span>
                </Card.Header>
                <Card.Body className=' p-1 px-2 font12 font-weight-bold'>
                    {   
                        attachment && (
                            <div className='w-100 d-flex py-2 flex-column'> 
                                {
                                    attachment?.docs  ?     
                                    attachment?.docs.map((p,i)=>(<a href={p.path} key={i} alt='source' download >{p.originalname}</a>)) :
                                    attachment?.images.map((p,i)=>( <img src={`./${p.path}`} key={i} alt={p.originalname} width='100%' className='py-1 shadow'/>  ))
                                }
                            </div>
                        )
                    }
                    {message}
                    <div className='text-right text-white m-0 font8 font-weight-light'>{time}</div>
                </Card.Body>
            </Card>
        </div>
    )
}

export default Message